export const SET_ORDERS = "SET_ORDERS";
export const CLEAR_STATE = "CLEAR_STATE";
export const SET_LAST_CLICKED_ELEMENT = "SET_LAST_CLICKED_ELEMENT";